import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { useIsVisible } from '../../../../components/Image/GalleryOverlay/hooks/useIsVisible.js';
import { NextImage } from '../../../../components/internal/NextImage/index.js';
import { Fade } from '../../../../primitives/index.js';
export const Image = ({
  src,
  alt,
  onClick
}) => {
  const [hasFinishedLoading, setHasFinishedLoading] = useState(false);
  const placeholderRef = useRef(null);
  const isVisible = useIsVisible(placeholderRef);
  const handleLoad = useCallback(() => {
    setHasFinishedLoading(true);
  }, []);
  return isVisible ? _jsx(Fade, {
    in: hasFinishedLoading,
    mountOnEnter: false,
    unmountOnExit: false,
    children: _jsx(NextImage, {
      image: src,
      alt: alt,
      onLoad: handleLoad,
      layout: "fill",
      objectFit: "cover",
      onClick: onClick
    })
  }) : _jsx("div", {
    ref: placeholderRef
  });
};